import * as React from 'react';
import { useState , useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { API } from '../../../service/api';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function Dropdown() {
    const navigate = useNavigate();
    const account = JSON.parse(localStorage.getItem('account'));

    const [isLoggedIn, setIsLoggedIn]=useState(false);

    useEffect(()=>{
      const checkLogin=()=>{
        if(account && account.email) 
        {
          setIsLoggedIn(true);
        }
        else{
          setIsLoggedIn(false);
        }
      }
      checkLogin();
    },[account])    

    const handleLogout=async()=>{
        await API.logoutUser();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('account');
        navigate('/login');
    }

    const handleProfile=()=>{
      navigate(`/profile/${account.email}/${true}`);
    }
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    
    const handleClicked = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

  return (
    <div>
      <Button
        variant="text"
        style={{textTransform:"none", color:"black"}}
        onClick={handleClicked}
        disableRipple
        endIcon={<KeyboardArrowDownIcon />}
      >
        My Profile
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfile} disableRipple>
            Profile
        </MenuItem>
        <MenuItem onClick={handleLogout} disableRipple>
          {isLoggedIn? 'Logout' : 'Login/Signup'}
        </MenuItem>
      </StyledMenu>
    </div>
  );
}